module.exports = __webpack_public_path__ + "static/media/p2jtxt.71ccb133.png";